import { ChevronRight, Home } from "lucide-react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

export const PathTrail = ({ path = [], size = "md", linkable = true, emptyLabel, testId = "path-trail" }) => {
  if (!path.length) return <span data-testid={testId} className="text-sm text-slate-400 italic">{emptyLabel}</span>;
  const big = size === "lg";
  return (
    <nav data-testid={testId} className="flex flex-wrap items-center gap-1 font-mono">
      {path.map((p, i) => {
        const last = i === path.length - 1;
        const cls = cn(
          "inline-flex items-center gap-1 rounded-md border transition-colors duration-200",
          big ? "px-2.5 py-1.5 text-sm" : "px-1.5 py-0.5 text-[11px]",
          last ? "bg-blue-600 border-blue-600 text-white font-semibold" : "bg-blue-50 border-blue-200 text-blue-800 hover:bg-blue-100"
        );
        const inner = <>{i === 0 && <Home className={big ? "w-3.5 h-3.5" : "w-3 h-3"} />}{p.name}</>;
        return (
          <span key={p.id} className="inline-flex items-center gap-1">
            {linkable ? <Link to={`/locations/${p.id}`} className={cls} onClick={(e) => e.stopPropagation()}>{inner}</Link> : <span className={cls}>{inner}</span>}
            {!last && <ChevronRight className={cn("text-slate-400 rtl:rotate-180", big ? "w-4 h-4" : "w-3 h-3")} />}
          </span>
        );
      })}
    </nav>
  );
};
